export const LOAD = "LOAD";

export function onLoad(data) {
  return {
    type: LOAD,
    data
  };
}

export function load(data) {
  return dispatch => {
    dispatch(onLoad(data));
  };
}



// WEBPACK FOOTER //
// ./src/actions/companyProfile.actions.js